module.exports = __webpack_public_path__ + "assets/icon-vet.5f4a05f8.svg";